<body>
  <ng-container *ngIf="percentDone == 0">
    <div class="div-center">
      <div class="row" *ngIf="creds.AuthType !== AuthTypeSSO">
        <div class="arrow-icon">
          <img src="assets/icons/bi--arrow-left.svg" (click)="Return2Login()" class="arrow-dir" alt="">
        </div>
      </div>
      <div class="row">
        <div class="logos mb-2">
          <div class="row align-items-center">
            <div class="col">
              <img class="buzz-logo" src="assets/images/logo-buzz.png" alt="">
            </div>
            <div class="col">
              <img class="customer-logo" [src]="imagePath" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="login-form">
          <h4>{{'SelectBU'|translate}}</h4>
          <form action="" (submit)="onContinueClick()">
            <ng-container *ngIf="apiError">
              <div class="alert alert-danger mb-3" role="alert">
                <i class="fa-solid fa-ban error"></i>
                {{apiError | translate}}
              </div>
            </ng-container>
            <div class="form-group mb-3">
              <label for="BusinessUnit" class="form-label">{{'BusinessUnit'|translate}}</label>
              <select id="BusinessUnit" (change)="selectionChange($event.target.value)" class="form-select" aria-label="business unit">
                <option *ngFor="let unit of listItems; index as i" [value]="i" [selected]="unit.BUID===defaultItem.BUID">{{ (unit.Description ?? '') +'(' + unit.BUID + ')' }}</option>
              </select>
            </div>

            <app-language-select *ngIf="creds.AuthType === AuthTypeSSO" (UpdateCredsLanguage)="UpdateCredsLanguage($event)"></app-language-select>

            <button type="submit" class="btn m-0">{{'Continue'|translate}}</button>
          </form>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="percentDone != 0">
    <app-loading-page [progress]="percentDone">
    </app-loading-page>
  </ng-container>
</body>
